import {Fragment, useRef, useState} from 'react';

import {Button} from 'primereact/button';
import {Calendar} from 'primereact/calendar';
import {InputText} from 'primereact/inputtext';
import {OverlayPanel} from 'primereact/overlaypanel';

import {FormatDisplay} from '../format';
import {useTranslation} from '../language';

export const DateTimeRange = ({type, value, onChange}) => {
  const {t} = useTranslation();

  const op = useRef(null);

  const [from, setFrom] = useState(null);
  const [to, setTo] = useState(null);

  const submit = e => {
    if (from && to) {
      if (type === 'date-time-range') {
        onChange(`${FormatDisplay.dateTime(from)} - ${FormatDisplay.dateTime(to)}`);
      } else {
        onChange(`${FormatDisplay.date(from)} - ${FormatDisplay.date(to)}`);
      }
    } else {
      onChange('');
    }
    op.current.hide(e);
  }

  return <Fragment>
    <InputText value={value || ''} onChange={e => onChange(e.target.value)} onClick={e => op.current.show(e)}/>

    <OverlayPanel ref={op}>
      <div className="p-fluid grid" style={{width: '60rem'}}>
        <div className="col-6">
          <Calendar value={from} onChange={e => setFrom(e.value)} showTime={type === 'date-time-range'} showSeconds={type === 'date-time-range'} inline={true}/>
        </div>
        <div className="col-6">
          <Calendar value={to} onChange={e => setTo(e.value)} showTime={type === 'date-time-range'} showSeconds={type === 'date-time-range'} inline={true}/>
        </div>
      </div>
      <div className="flex justify-content-between">
        <div></div>
        <Button label={t('common.confirm')} className="p-button-rounded" onClick={submit}/>
      </div>
    </OverlayPanel>
  </Fragment>
}
